import React from 'react';
import { AfterSubmitFunc, useShowContextRequired } from 'ui-builder';
import { TasksGroup, useTasksGroupsAdminService } from 'nekst-api';
import { OpenFormIconButton } from 'features/nekst-widgets';
import BaseTasksGroupAdminForm from './BaseTasksGroupAdminForm';

function UpdateTasksGroupAdminForm(
  props: {
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {
  const tasksGroupsAdminService = useTasksGroupsAdminService();
  const showContext = useShowContextRequired<TasksGroup>();

  return (
    <BaseTasksGroupAdminForm
      submitFormFunc={async (data) => {
        return await tasksGroupsAdminService.updateTasksGroup(showContext.data!.id, data);
      }}
      initialData={showContext.data!}
      title="Update Tasks Group"
      afterSubmitFunc={props.afterSubmitFunc}
    />
  )
}

export function UpdateTasksGroupAdminButton() {
  return (
    <OpenFormIconButton
      form={<UpdateTasksGroupAdminForm />}
    />
  );
}
